import { trackGa4 } from './ga4'

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: Record<string, unknown> }) => void
    dataLayer?: unknown[]
  }
}

export function track(event: string, props: Record<string, unknown> = {}) {
  if (navigator.doNotTrack === '1') return
  window.plausible?.(event, { props })
  trackGa4(event)
  const base = import.meta.env.VITE_API_URL
  if (!base) return
  void fetch(`${base}/v1/marketing/events`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
    body: JSON.stringify({ name: event, path: window.location.pathname,
      location: typeof props.location === 'string' ? props.location : null,
      cta: typeof props.cta === 'string' ? props.cta : null }),
  }).catch(() => {})
}

export function getAttribution(search = window.location.search) {
  const params = new URLSearchParams(search)
  return {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    term: params.get('utm_term'),
    content: params.get('utm_content'),
    landingPage: window.location.pathname + window.location.search,
    referrer: document.referrer || null,
  }
}
